import { departmentFilter } from 'containers/Pages/People/Personnel/Layouts/options.jsx';

const getSiteFilter = bizClients => ({
  archive: {
    label: 'Archived',
    field: 'archived',
    type: 'toggle',
  },
  businessClient: {
    label: 'businessClient',
    field: 'businessClient',
    type: 'select',
    options: bizClients,
  },
});
export const filters = ({ bizClients, userAssignedDepartments = [] }) => {
  const departmentFilterField = departmentFilter(userAssignedDepartments);
  const { archive, businessClient } = getSiteFilter(bizClients);
  return {
    RegularFilters: [archive, businessClient],
    AdvancedFilters: [...departmentFilterField],
  };
};
